import dayjs from "dayjs";

export const formatPhoneNumber = (phoneNumber: string): string => {
  const digits = phoneNumber.replace(/\D/g, "");

  if (digits.length < 10) {
    return phoneNumber;
  } else if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length === 11) {
    return `${digits.slice(0, 1)}-${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
  } else {
    return digits;
  }
};

export const formatDateString = (date: string, format: string, showToday = false) => {
  const formattedString = dayjs.utc(date).format(format);
  if (showToday) {
    if (formattedString === dayjs().utc().format(format)) {
      return "Today";
    } else if (formattedString === dayjs().subtract(1, "day").utc().format(format)) {
      return "Yesterday";
    }
  }
  return formattedString;
};
